import axios from 'axios';

export async function verifySmsMfa(verificationCode) {
  const {data} = await axios.post(`/api/?entity=twoFactorAuthentication&action=sms2faVerify`, {
    verification_code: verificationCode,
  });

  return data.data;
}
